import FormatCurrency from 'components/Common/FormatCurrency'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React from 'react'

interface Props {
  nightlyBudget: number
  offersCredits: boolean
  totalBudget: number
}

export function BusinessTravellerBudgetInfoModal(props: Props) {
  const { nightlyBudget, totalBudget, offersCredits } = props

  return (
    <Modal
      title="Accommodation budget"
    >
      <VerticalSpacer gap={16}>
        <BodyText variant="large" weight="normal">
          Your Business Traveller Admin has set a nightly accommodation budget of <FormatCurrency value={nightlyBudget} format="dynamicDollar"/>/room. As per your trip requirements, the total accommodation budget for your stay is set at <FormatCurrency value={totalBudget} format="dynamicDollar"/>.
        </BodyText>
        { offersCredits && <>
          <BodyText variant="large" weight="normal">
            When you book accommodation within your budget you may be eligible to earn Luxury Escapes credit to redeem on personal travel through your Personal Profile.
          </BodyText>
          <BodyText variant="large" weight="normal">
            Credits earned are valid for all Limited Time Lux Exclusive, Lux Premium Collection and Lux Partner Property offers.
          </BodyText>
        </>
        }
      </VerticalSpacer>
    </Modal>
  )
}
